/* tslint:disable */
/* eslint-disable */
/**
 * pinnacle-backend API spec
 * Backend Service for Pinnacle Underwriting | [swagger.json](pinnacle/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ChangelogResponseDto } from './ChangelogResponseDto';
import {
    ChangelogResponseDtoFromJSON,
    ChangelogResponseDtoFromJSONTyped,
    ChangelogResponseDtoToJSON,
    ChangelogResponseDtoToJSONTyped,
} from './ChangelogResponseDto';
import type { MeResponseDto } from './MeResponseDto';
import {
    MeResponseDtoFromJSON,
    MeResponseDtoFromJSONTyped,
    MeResponseDtoToJSON,
    MeResponseDtoToJSONTyped,
} from './MeResponseDto';
import type { InsuredResponseDto } from './InsuredResponseDto';
import {
    InsuredResponseDtoFromJSON,
    InsuredResponseDtoFromJSONTyped,
    InsuredResponseDtoToJSON,
    InsuredResponseDtoToJSONTyped,
} from './InsuredResponseDto';
import type { LayerResponseDto } from './LayerResponseDto';
import {
    LayerResponseDtoFromJSON,
    LayerResponseDtoFromJSONTyped,
    LayerResponseDtoToJSON,
    LayerResponseDtoToJSONTyped,
} from './LayerResponseDto';
import type { UploadedFileResponseDto } from './UploadedFileResponseDto';
import {
    UploadedFileResponseDtoFromJSON,
    UploadedFileResponseDtoFromJSONTyped,
    UploadedFileResponseDtoToJSON,
    UploadedFileResponseDtoToJSONTyped,
} from './UploadedFileResponseDto';
import type { TotalTivViewResponseDto } from './TotalTivViewResponseDto';
import {
    TotalTivViewResponseDtoFromJSON,
    TotalTivViewResponseDtoFromJSONTyped,
    TotalTivViewResponseDtoToJSON,
    TotalTivViewResponseDtoToJSONTyped,
} from './TotalTivViewResponseDto';

/**
 * 
 * @export
 * @interface SubmissionResponseDto
 */
export interface SubmissionResponseDto {
    /**
     * 
     * @type {Date}
     * @memberof SubmissionResponseDto
     */
    createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof SubmissionResponseDto
     */
    updatedAt: Date;
    /**
     * 
     * @type {string}
     * @memberof SubmissionResponseDto
     */
    submissionId: string;
    /**
     * 
     * @type {string}
     * @memberof SubmissionResponseDto
     */
    transactionType: SubmissionResponseDtoTransactionTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof SubmissionResponseDto
     */
    placingType: string;
    /**
     * 
     * @type {string}
     * @memberof SubmissionResponseDto
     */
    lineOfBusiness: string;
    /**
     * 
     * @type {string}
     * @memberof SubmissionResponseDto
     */
    policyType: SubmissionResponseDtoPolicyTypeEnum;
    /**
     * 
     * @type {TotalTivViewResponseDto}
     * @memberof SubmissionResponseDto
     */
    totalTivView?: TotalTivViewResponseDto;
    /**
     * 
     * @type {string}
     * @memberof SubmissionResponseDto
     */
    assignedHandlerId: string;
    /**
     * 
     * @type {string}
     * @memberof SubmissionResponseDto
     */
    namedUnderwriterId?: string;
    /**
     * 
     * @type {Date}
     * @memberof SubmissionResponseDto
     */
    inceptionDate: Date;
    /**
     * 
     * @type {Date}
     * @memberof SubmissionResponseDto
     */
    expiryDate?: Date;
    /**
     * 
     * @type {string}
     * @memberof SubmissionResponseDto
     */
    principalOccupation?: string;
    /**
     * 
     * @type {string}
     * @memberof SubmissionResponseDto
     */
    subClass: string;
    /**
     * 
     * @type {string}
     * @memberof SubmissionResponseDto
     */
    mainRegionAndRiskTerritory?: string;
    /**
     * 
     * @type {string}
     * @memberof SubmissionResponseDto
     */
    keyRiskLocation?: string;
    /**
     * 
     * @type {string}
     * @memberof SubmissionResponseDto
     */
    originalCurrency?: string;
    /**
     * 
     * @type {string}
     * @memberof SubmissionResponseDto
     */
    status: SubmissionResponseDtoStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof SubmissionResponseDto
     */
    insuredId: string;
    /**
     * 
     * @type {string}
     * @memberof SubmissionResponseDto
     */
    shareOfPremiumSigned?: string;
    /**
     * 
     * @type {InsuredResponseDto}
     * @memberof SubmissionResponseDto
     */
    insured?: InsuredResponseDto;
    /**
     * 
     * @type {Array<LayerResponseDto>}
     * @memberof SubmissionResponseDto
     */
    layers?: Array<LayerResponseDto>;
    /**
     * 
     * @type {Array<ChangelogResponseDto>}
     * @memberof SubmissionResponseDto
     */
    changelogs?: Array<ChangelogResponseDto>;
    /**
     * 
     * @type {MeResponseDto}
     * @memberof SubmissionResponseDto
     */
    assignedHandler?: MeResponseDto;
    /**
     * 
     * @type {MeResponseDto}
     * @memberof SubmissionResponseDto
     */
    namedUnderwriter?: MeResponseDto;
    /**
     * 
     * @type {Array<UploadedFileResponseDto>}
     * @memberof SubmissionResponseDto
     */
    files?: Array<UploadedFileResponseDto>;
}


/**
 * @export
 */
export const SubmissionResponseDtoTransactionTypeEnum = {
    Renewal: 'Renewal',
    NewBusiness: 'New Business'
} as const;
export type SubmissionResponseDtoTransactionTypeEnum = typeof SubmissionResponseDtoTransactionTypeEnum[keyof typeof SubmissionResponseDtoTransactionTypeEnum];

/**
 * @export
 */
export const SubmissionResponseDtoPolicyTypeEnum = {
    Reinsurance: 'Reinsurance',
    Insurance: 'Insurance'
} as const;
export type SubmissionResponseDtoPolicyTypeEnum = typeof SubmissionResponseDtoPolicyTypeEnum[keyof typeof SubmissionResponseDtoPolicyTypeEnum];

/**
 * @export
 */
export const SubmissionResponseDtoStatusEnum = {
    Prospect: 'Prospect',
    Pending: 'Pending',
    Quoted: 'Quoted',
    Declined: 'Declined',
    Cancelled: 'Cancelled',
    Complete: 'Complete'
} as const;
export type SubmissionResponseDtoStatusEnum = typeof SubmissionResponseDtoStatusEnum[keyof typeof SubmissionResponseDtoStatusEnum];


/**
 * Check if a given object implements the SubmissionResponseDto interface.
 */
export function instanceOfSubmissionResponseDto(value: object): value is SubmissionResponseDto {
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    if (!('submissionId' in value) || value['submissionId'] === undefined) return false;
    if (!('transactionType' in value) || value['transactionType'] === undefined) return false;
    if (!('placingType' in value) || value['placingType'] === undefined) return false;
    if (!('lineOfBusiness' in value) || value['lineOfBusiness'] === undefined) return false;
    if (!('policyType' in value) || value['policyType'] === undefined) return false;
    if (!('assignedHandlerId' in value) || value['assignedHandlerId'] === undefined) return false;
    if (!('inceptionDate' in value) || value['inceptionDate'] === undefined) return false;
    if (!('subClass' in value) || value['subClass'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('insuredId' in value) || value['insuredId'] === undefined) return false;
    return true;
}

export function SubmissionResponseDtoFromJSON(json: any): SubmissionResponseDto {
    return SubmissionResponseDtoFromJSONTyped(json, false);
}

export function SubmissionResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): SubmissionResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'createdAt': (new Date(json['createdAt'])),
        'updatedAt': (new Date(json['updatedAt'])),
        'submissionId': json['submissionId'],
        'transactionType': json['transactionType'],
        'placingType': json['placingType'],
        'lineOfBusiness': json['lineOfBusiness'],
        'policyType': json['policyType'],
        'totalTivView': json['totalTivView'] == null ? undefined : TotalTivViewResponseDtoFromJSON(json['totalTivView']),
        'assignedHandlerId': json['assignedHandlerId'],
        'namedUnderwriterId': json['namedUnderwriterId'] == null ? undefined : json['namedUnderwriterId'],
        'inceptionDate': (new Date(json['inceptionDate'])),
        'expiryDate': json['expiryDate'] == null ? undefined : (new Date(json['expiryDate'])),
        'principalOccupation': json['principalOccupation'] == null ? undefined : json['principalOccupation'],
        'subClass': json['subClass'],
        'mainRegionAndRiskTerritory': json['mainRegionAndRiskTerritory'] == null ? undefined : json['mainRegionAndRiskTerritory'],
        'keyRiskLocation': json['keyRiskLocation'] == null ? undefined : json['keyRiskLocation'],
        'originalCurrency': json['originalCurrency'] == null ? undefined : json['originalCurrency'],
        'status': json['status'],
        'insuredId': json['insuredId'],
        'shareOfPremiumSigned': json['shareOfPremiumSigned'] == null ? undefined : json['shareOfPremiumSigned'],
        'insured': json['insured'] == null ? undefined : InsuredResponseDtoFromJSON(json['insured']),
        'layers': json['layers'] == null ? undefined : ((json['layers'] as Array<any>).map(LayerResponseDtoFromJSON)),
        'changelogs': json['changelogs'] == null ? undefined : ((json['changelogs'] as Array<any>).map(ChangelogResponseDtoFromJSON)),
        'assignedHandler': json['assignedHandler'] == null ? undefined : MeResponseDtoFromJSON(json['assignedHandler']),
        'namedUnderwriter': json['namedUnderwriter'] == null ? undefined : MeResponseDtoFromJSON(json['namedUnderwriter']),
        'files': json['files'] == null ? undefined : ((json['files'] as Array<any>).map(UploadedFileResponseDtoFromJSON)),
    };
}

export function SubmissionResponseDtoToJSON(json: any): SubmissionResponseDto {
    return SubmissionResponseDtoToJSONTyped(json, false);
}

export function SubmissionResponseDtoToJSONTyped(value?: SubmissionResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'createdAt': ((value['createdAt']).toISOString()),
        'updatedAt': ((value['updatedAt']).toISOString()),
        'submissionId': value['submissionId'],
        'transactionType': value['transactionType'],
        'placingType': value['placingType'],
        'lineOfBusiness': value['lineOfBusiness'],
        'policyType': value['policyType'],
        'totalTivView': TotalTivViewResponseDtoToJSON(value['totalTivView']),
        'assignedHandlerId': value['assignedHandlerId'],
        'namedUnderwriterId': value['namedUnderwriterId'],
        'inceptionDate': ((value['inceptionDate']).toISOString()),
        'expiryDate': value['expiryDate'] == null ? undefined : ((value['expiryDate']).toISOString()),
        'principalOccupation': value['principalOccupation'],
        'subClass': value['subClass'],
        'mainRegionAndRiskTerritory': value['mainRegionAndRiskTerritory'],
        'keyRiskLocation': value['keyRiskLocation'],
        'originalCurrency': value['originalCurrency'],
        'status': value['status'],
        'insuredId': value['insuredId'],
        'shareOfPremiumSigned': value['shareOfPremiumSigned'],
        'insured': InsuredResponseDtoToJSON(value['insured']),
        'layers': value['layers'] == null ? undefined : ((value['layers'] as Array<any>).map(LayerResponseDtoToJSON)),
        'changelogs': value['changelogs'] == null ? undefined : ((value['changelogs'] as Array<any>).map(ChangelogResponseDtoToJSON)),
        'assignedHandler': MeResponseDtoToJSON(value['assignedHandler']),
        'namedUnderwriter': MeResponseDtoToJSON(value['namedUnderwriter']),
        'files': value['files'] == null ? undefined : ((value['files'] as Array<any>).map(UploadedFileResponseDtoToJSON)),
    };
}

